!function() {
    "use strict";
    const e = "[data-video-template]",
          t = "is-loading",
          i = "data-video-id",
          btnClass = ".playvideo_onclick";

    customElements.get("video-background") || customElements.define("video-background", class extends HTMLElement {
        constructor() {
            super();
            this.handleManualPlay = this.handleManualPlay.bind(this);
        }

        connectedCallback() {
            this.videoId = this.getAttribute(i);
            this.videoTemplate = this.querySelector(e);
            this.video = null;
            this.playButton = null;
            this.powerSaverVideoPlay = this.powerSaverVideoPlay.bind(this);
            this.videoId && this.renderVideo();
        }

        powerSaverVideoPlay() {
            this.video?.play();
        }

        renderVideo() {
            this.videoTemplateObserver = new IntersectionObserver(((entries, observer) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const o = this.videoTemplate.innerHTML;
                        this.innerHTML = o;
                        this.classList.remove(t);
                        this.video = this.querySelector("video");
                        this.playButton = this.querySelector(btnClass);
                        if (this.video) {
                         
                            const autoplay = this.video.hasAttribute('autoplay');
                            if (!autoplay && this.playButton) {
                                this.video.style.display = 'none';
                                this.video.controls = false;
                                this.playButton.style.display = 'block';
                                this.playButton.style.cursor = 'pointer';
                                this.playButton.addEventListener('click', this.handleManualPlay);
                            }

                            this.observeVideoPlayToggle();

                            if (autoplay) {
                                this.video.play().catch(() => {
                                    document.addEventListener("click", this.powerSaverVideoPlay, { passive: !0, once: !0 });
                                    document.addEventListener("touchstart", this.powerSaverVideoPlay, { passive: !0, once: !0 });
                                });
                            }

                        }

                        observer.unobserve(entry.target);
                    }
                });
            }), {
                root: null,
                rootMargin: "300px",
                threshold: [0, .1, .25, .5, .75, 1]
            });
            this.videoTemplateObserver.observe(this);
        }

        handleManualPlay() {
          console.log("sdfsd",this.video);
            if (!this.video) return;
            this.video.play().then(() => {
                this.video.controls = true;
                if (this.playButton) {
                  this.video.style.display = 'block';
                  this.playButton.style.display = 'none';
                }
            }).catch(() => {
                console.log("Manual play failed.");
            });
        }

        observeVideoPlayToggle() {
            if (!this.video) return;
            this.videoPlayObserver = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        if (this.video.hasAttribute('autoplay')) {
                            this.video.play().catch(() => {});
                        }
                    } else {
                        this.video.pause();
                    }
                });
            }, {
                rootMargin: "0px",
                threshold: [0, 1]
            });
            this.videoPlayObserver.observe(this.video);
        }

        disconnectedCallback() {
            this.videoTemplateObserver && this.videoTemplateObserver.disconnect();
            this.videoPlayObserver && this.videoPlayObserver.disconnect();
            if (this.playButton) {
                this.playButton.removeEventListener('click', this.handleManualPlay);
            }
            this.videoId && (
                document.removeEventListener("click", this.powerSaverVideoPlay),
                document.removeEventListener("touchstart", this.powerSaverVideoPlay)
            );
        }
    });
}();
